import React, { useState } from 'react';
import Header from '../../../components/Header';
import { Plus } from 'lucide-react';
import ComponentHeader from '../../../components/ComponentHeader';
import LeaveRoasterTable from './LeaveRoasterTable';
import LeaveRosterModal from '../../../components/LeaveRoasterModal';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const LeaveRoster = () => {
  const navigate = useNavigate();
  const role = useSelector((state: any) => state.user?.role);
  const [openModal, setOpenModal] = useState(false);
  const [editId, setEditId] = useState<number | null>(null);
  const [refresh, setRefresh] = useState(0);
  const [search, setSearch] = useState('');

  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState<'success' | 'error' | ''>('');

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <Header title={'Leave Roster'} />

      <div className="flex-1 overflow-auto">
        <div className="flex justify-between items-center mb-4">
          {role === 'shift_supervisor' && (
            <button
              onClick={() => {
                setEditId(null);
                setOpenModal(true);
              }}
              className="flex items-center gap-2 bg-[#e84545] text-white ml-6 px-4 py-2 rounded-md text-sm font-medium mt-6"
            >
              <Plus size={16} />
              Leave Roster
            </button>
          )}

          {/* Assuming ComponentHeader accepts an onSearch callback — adjust the prop name
              to match its actual signature if it's different (e.g. searchValue/onSearchChange) */}
          <ComponentHeader onSearch={(value: string) => setSearch(value)} />
        </div>

        {message && (
          <div className="fixed bottom-6 right-6 z-[9999] animate-slide-in">
            <div
              className={`w-[380px] rounded-xl shadow-2xl px-5 py-5 text-white flex justify-between items-start ${
                messageType === 'success' ? 'bg-green-500' : 'bg-red-500'
              }`}
            >
              <div className="flex items-start gap-3">
                <div className="mt-1">
                  {messageType === 'success' ? (
                    <svg width="30" height="30" fill="none" stroke="white" strokeWidth="2" viewBox="0 0 24 24">
                      <path d="M9 12l2 2 4-4" />
                      <circle cx="12" cy="12" r="9" />
                    </svg>
                  ) : (
                    <svg width="30" height="30" fill="none" stroke="white" strokeWidth="2" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="9" />
                      <path d="M12 8v5" />
                      <path d="M12 16h.01" />
                    </svg>
                  )}
                </div>

                <div>
                  <h3 className="text-2xl font-semibold">{messageType === 'success' ? 'Success' : 'Error'}</h3>

                  <p className="mt-2 text-base">{message}</p>
                </div>
              </div>

              <button onClick={() => setMessage('')} className="text-white text-2xl leading-none">
                ×
              </button>
            </div>
          </div>
        )}

        <LeaveRoasterTable
          search={search}
          refresh={refresh}
          onView={(id) => {
            navigate(`/LeaveRoster/${id}`);
          }}
          onEdit={(id) => {
            setEditId(id);
            setOpenModal(true);
          }}
          setMessage={setMessage}
          setMessageType={setMessageType}
        />

        <LeaveRosterModal
          isOpen={openModal}
          editId={editId}
          onClose={() => {
            setOpenModal(false);
            setEditId(null);
          }}
          onSuccess={() => {
            setOpenModal(false);
            setRefresh((prev) => prev + 1);
          }}
          setMessage={setMessage}
          setMessageType={setMessageType}
        />
      </div>
    </div>
  );
};

export default LeaveRoster;
